import Vue from 'vue';
import recipeIngredienceTransformer from '../../transformers/recipeIngredience';
import store from '../../store';

const success = ({ data }) => recipeIngredienceTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const recipeIngrediences = store.state.recipeIngredience.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (recipeIngrediences.length > 0) {
      return resolve(recipeIngrediences[0]);
    }

    return Vue.$http.get(`/production/recipe_ingredience/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeIngredience/show.js